import { render, staticRenderFns } from "./TitleValue.vue?vue&type=template&id=2559d476&scoped=true&"
import script from "./TitleValue.vue?vue&type=script&lang=js&"
export * from "./TitleValue.vue?vue&type=script&lang=js&"
import style0 from "./TitleValue.vue?vue&type=style&index=0&id=2559d476&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2559d476",
  null
  
)

export default component.exports